import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveResourceGroupsRequestFailure(namespace) {
      const result = getState().find(
        (result) => result.namespace === namespace,
      );

      return result ? result.request.isFailure : false;
    },
    isRetrieveResourceGroupsRequestPending(namespace) {
      const result = getState().find(
        (result) => result.namespace === namespace,
      );

      return result ? result.request.isPending : false;
    },
    isRetrieveResourceGroupsRequestSuccess(namespace) {
      const result = getState().find(
        (result) => result.namespace === namespace,
      );

      return result ? result.request.isSuccessful : false;
    },
    getResourceGroups(namespace) {
      const result = getState().find(
        (result) => result.namespace === namespace,
      );

      return result ? result.groups : [];
    },
  };
}

export { createSelector };
